module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/client_five-ea2eefd74ee2c46528178dcb7a683c28.png";